import AdminShell from './admin/AdminShell'
import AdminUiProvider from './admin/AdminUiProvider'

interface AdminDashboardProps {
  token: string
  onLastUpdated?: (date: Date) => void
}

export default function AdminDashboard({ token, onLastUpdated }: AdminDashboardProps) {
  return (
    <AdminUiProvider>
      <section className="vc-admin-page vc-admin-page--portal">
        <AdminShell token={token} onLastUpdated={onLastUpdated} />
      </section>
    </AdminUiProvider>
  )
}
